import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import { WaveSmallLeaderboardTopThreeDrop } from "./WaveSmallLeaderboardTopThreeDrop";
import { WaveSmallLeaderboardDefaultDrop } from "./WaveSmallLeaderboardDefaultDrop";
interface DefaultWaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: () => void;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const DefaultWaveSmallLeaderboardDrop: React.FC<DefaultWaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(7);
  const {
    drop,
    onDropClick,
    contentPresentation: t1
  } = t0;
  const contentPresentation = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== contentPresentation || $[1] !== drop || $[2] !== onDropClick) {
    t2 = typeof drop.rank === "number" && drop.rank <= 3 ? <WaveSmallLeaderboardTopThreeDrop drop={drop} onDropClick={onDropClick} contentPresentation={contentPresentation} /> : <WaveSmallLeaderboardDefaultDrop drop={drop} onDropClick={onDropClick} contentPresentation={contentPresentation} />;
    $[0] = contentPresentation;
    $[1] = drop;
    $[2] = onDropClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onDropClick || $[5] !== t2) {
    t3 = <div className="tw-cursor-pointer" onClick={onDropClick}>{t2}</div>;
    $[4] = onDropClick;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};